import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { whoAmI, logout as logoutApi, getToken } from '../lib/auth';

const AuthCtx = createContext({
  user: null,
  loading: true,
  setUser: () => {},
  signOut: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  // Loading is true until the initial /auth/me resolves (or there's no
  // token at all). Gating the app on this prevents a flash of the chat
  // UI for users who already have a valid session.
  const [loading, setLoading] = useState(() => !!getToken());

  useEffect(() => {
    let alive = true;
    if (!getToken()) {
      setLoading(false);
      return undefined;
    }
    whoAmI().then((u) => {
      if (!alive) return;
      setUser(u);
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);

  const signOut = useCallback(async () => {
    await logoutApi();
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, setUser, signOut }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
